import React from "react";
import { useLang } from "@/context/LanguageContext";

const HowItWorks = () => {
  const { t } = useLang();
  return (
    <section data-testid="how-it-works-section" className="py-16 md:py-32 bg-maif-2/30">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-16">
          <div className="eyebrow">{t.process.eyebrow}</div>
          <h2 className="mt-4 font-display font-light text-4xl md:text-5xl tracking-tight text-maif">
            {t.process.title}
          </h2>
        </div>

        <div className="relative grid grid-cols-1 md:grid-cols-4 gap-8">
          <div
            aria-hidden
            className="hidden md:block absolute top-12 left-0 right-0 h-px bg-sand-soft"
          />
          {t.process.steps.map((s, i) => (
            <div
              key={i}
              data-testid={`step-${i}`}
              className="relative z-10 bg-maif pt-2 pr-4"
            >
              <div className="flex items-center gap-4">
                <span className="inline-flex h-12 w-12 rounded-full border border-sand-mid bg-maif-2 items-center justify-center font-accent italic text-xl text-terracotta">
                  {s.n}
                </span>
                <span className="hairline flex-1" />
              </div>
              <h3 className="mt-6 font-display text-2xl text-maif tracking-tight">{s.title}</h3>
              <p className="mt-3 text-maif-muted leading-relaxed text-sm md:text-base">
                {s.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
